import { render } from "./Github-user.vue?vue&type=template&id=20781163"
import script from "./Github-user.vue?vue&type=script&lang=ts"
export * from "./Github-user.vue?vue&type=script&lang=ts"

import "./Github-user.vue?vue&type=style&index=0&id=20781163&lang=scss"
script.render = render

export default script